import ColorTabs from './ColorTabs.container';

export default ColorTabs;
